import { isMobile } from '@pascal/pascal-core';

import { GameApplicationType } from '../../enums/GameApplicationType';
import { GameDrawerWeb } from './gameDrawer/gameDrawer';
import { mobileConfigs, webConfigs } from '../../core/pixi/configs';
import { DrawerBase } from '../../core/pixi/DrawerBase';
import { GameDrawerMobile } from './gameDrawer/gameDrawer.mobile';

class GameDrawer extends DrawerBase {
  constructor(drawers) {
    super();
    this.drawers = drawers;
    this.applications = {
      [GameApplicationType.Web]: this.createApplication(webConfigs.applicationConfigs),
      [GameApplicationType.Mobile]: this.createApplication(mobileConfigs.applicationConfigs),
    };
    this.drawers[GameApplicationType.Web].parent = this.applications[GameApplicationType.Web];
    this.drawers[GameApplicationType.Mobile].parent = this.applications[GameApplicationType.Mobile];
  }

  get parent() {
    const gameMode = isMobile() ? GameApplicationType.Mobile : GameApplicationType.Web;
    return this.applications[gameMode];
  }

  setupRoot(root) {
    if (!root.children.length) {
      root.appendChild(this.parent.view);
    }
  }

  execute({ mode, scene, prevScene }) {
    return new Promise((resolve) => {
      this.drawers[mode].execute({ scene, parent: this.parent.stage, prevScene }).then(() => {
        resolve(true);
      });
    });
  }
}

export const gameDrawer = new GameDrawer({
  [GameApplicationType.Web]: new GameDrawerWeb(webConfigs),
  [GameApplicationType.Mobile]: new GameDrawerMobile(mobileConfigs),
});
